import React, {Component} from 'react'
import {Line} from 'react-chartjs-2'
import * as PropTypes from "prop-types";
import Paper from "@material-ui/core/Paper";
import MuiTable from "../common/MuiTable";
import {NotificationManager} from "react-notifications";
import {organisationDetails, saveOrUpdateOrganisationDetails} from "../../util/ApiUtils";

const options = {
    scales: {
        yAxes: [{
            scaleLabel: {
                display: true,
                labelString: 'No of Complaints'
            },
            ticks: {
                min: 0
            }
        }],
        xAxes: [{
            scaleLabel: {
                display: true,
                labelString: 'Date'
            }
        }],
    }
}

const data = {
    labels: [],
    datasets: [
        {
            label: 'Customer Complaints',
            fill: false,
            backgroundColor: '#1a73e8',
            borderColor: 'rgba(255,99,132,1)',
            borderWidth: 1,
            hoverBackgroundColor: 'rgba(255,99,132,0.4)',
            hoverBorderColor: 'rgba(255,99,132,1)',
            data: []
        }
    ]
};

const months = { 1: 'Jan', 2: 'Feb', 3: 'Mar', 4: 'Apr', 5: 'May', 6: 'Jun', 7: 'Jul', 8: 'Aug', 9: 'Sep', 10: 'Oct', 11: 'Nov', 12: 'Dec' };

const muiColumns = [
    {
        title: 'id',
        field: 'id',
        type: "numeric",
        hidden: true,
    },
    { title: 'Month', field: 'month', lookup: { 'Jan': 'Jan', 'Feb': 'Feb', 'Mar': 'Mar', 'Apr': 'Apr', 'May': 'May', 'Jun': 'Jun', 'Jul': 'Jul', 'Aug': 'Aug', 'Sep': 'Sep', 'Oct': 'Oct', 'Nov': 'Nov', 'Dec': 'Dec' }},
    { title: 'Year', field: 'year'},
    { title: '# of Complaints', field: 'noOfComplaints', headerStyle: { width: "50%" } },
];

class CustomerComplaints extends Component {

    constructor(props) {
        super(props);
        this.loadOrganisationDetails = this.loadOrganisationDetails.bind(this);
        this.isValid = this.isValid.bind(this);
        this.handleAdd = this.handleAdd.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
        this.handleUpdate = this.handleUpdate.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {
        this.loadOrganisationDetails();
    }

    loadOrganisationDetails() {
        organisationDetails()
            .then(response => {
                console.log('organisation response', response);
                let sorted = response.customerComplaints.sort(function(a, b) {
                    let am = Object.keys(months).find(key => months[key] === a.month)
                    let bm = Object.keys(months).find(key => months[key] === b.month)
                    return a.year - b.year || am - bm;
                });
                console.log('sorted complaints', response.customerComplaints);
                data.labels = [];
                data.datasets[0].data = [];
                sorted.forEach((element) => {
                    data.labels.push(element.month + ' ' + element.year)
                    data.datasets[0].data.push(element.noOfComplaints)
                })
                this.setState({
                    organisation: response,
                    orgId: response.id,
                    customerComplaints: sorted,
                    isLoading: false
                });
            })
            .catch(error => {
                console.log(error);
            });
    }

    isValid(newData) {
        let isValid = newData.month && newData.month !== '' && newData.year && newData.year !== '' && newData.noOfComplaints && newData.noOfComplaints !== '';
        if (!isValid) {
            NotificationManager.error('Error', 'Validation Error. Please enter all the required fields', 5000);
        }
        return isValid;
    }

    handleUpdate(toUpdate) {
        console.log("updating to ", toUpdate);
        for (let i = 0, l = this.state.organisation.customerComplaints.length; i < l; i++) {
            if (this.state.organisation.customerComplaints[i].id === toUpdate.id) {
                this.state.organisation.customerComplaints[i].month = toUpdate.month;
                this.state.organisation.customerComplaints[i].year = toUpdate.year;
                this.state.organisation.customerComplaints[i].noOfComplaints = toUpdate.noOfComplaints;
            }
        }
        console.log("After update:", this.state.organisation.customerComplaints);
        this.handleSubmit(this.state.organisation.customerComplaints);
    }

    handleDelete(toDelete) {
        let customerComplaints = [];
        const index = this.state.organisation.customerComplaints.findIndex(x => x.id === toDelete.id);
        for (let i = 0, l = this.state.organisation.customerComplaints.length; i < l; i++) {
            if (i !== index) {
                customerComplaints.push(this.state.organisation.customerComplaints[i]);
            }
        }
        console.log("After removal:", customerComplaints);
        this.handleSubmit(customerComplaints);
    }

    handleAdd(data) {
        this.state.organisation.customerComplaints.push(data);
        this.handleSubmit(this.state.organisation.customerComplaints);
    }

    handleSubmit(data) {
        this.state.organisation.customerComplaints = data;
        saveOrUpdateOrganisationDetails(this.state.organisation)
            .then(() => {
                NotificationManager.success('Success', 'The Data have been updated.', 5000);
                this.loadOrganisationDetails();
                this.props.onChanged(this.state.organisation.customerComplaints);
            }).catch(error => {
            console.log("error");
            console.log(error);
            NotificationManager.error('Error', 'Sorry! Something went wrong. Please try again!', 5000);
        });
    }

    render() {
        return (
        // A react-chart hyper-responsively and continuously fills the available
        // space of its parent element automatically
        <div>
            {this.props.isEdit ?
                <React.Fragment>
                    <Paper style={{ marginTop: '30px' }}>
                        <MuiTable
                            title="Customer Complaints"
                            columns={muiColumns}
                            data={this.state.customerComplaints}
                            onAdd={this.handleAdd}
                            onUpdate={this.handleUpdate}
                            onDelete={this.handleDelete}
                            isValid={this.isValid}
                            exportButton={false}
                            search={false}
                            pageSize={20}
                            headerStyle={{ background: "lightblue" }}
                        />
                    </Paper>
                </React.Fragment>
            :
            <Line
                data={data}
                width={400}
                height={300}
                options={options}
                redraw
            />}
        </div>
    )};
}

CustomerComplaints.propTypes = {
    isEdit: PropTypes.bool.isRequired,
    onChanged: PropTypes.func.isRequired,
}
export default CustomerComplaints;